

const getDateFromTimeString = (timeString):Date => {
    const regex = /^(\d{4})-(\d{2})-(\d{2})(?: (\d{2})(?::(\d{2})(?::(\d{2}))?)?)?$/;
    const match = timeString.match(regex);
  
    if (match) {
      const [ , year, month, day, hours = 0, minutes = 0, seconds = 0 ] = match;
      return new Date(year, month - 1, day, hours, minutes, seconds);
    } else {
      throw new Error('Invalid date string');
    }
}

const getDateFromDateString = (dateString):Date => {
  const regex = /^(\d{4})-(\d{2})-(\d{2})$/;
  const match = dateString.match(regex);

  if (match) {
    const [ , year, month, day] = match;
    return new Date(year, month - 1, day);
  } else {
    throw new Error('Invalid date string');
  }
}

const getForeMonth = (date: Date): Date => {
    // 获取当前日期的年份和月份
    let year = date.getFullYear();
    let month = date.getMonth();
  
    // 计算上一个月的年份和月份
    if (month === 0) {
      // 如果当前月份是1月，则上一个月是去年的12月
      year--;
      month = 11; // 12月对应的索引是11
    } else {
      // 否则，直接取前一个月
      month--;
    }
  
    // 构造并返回上一个月的日期对象
    return new Date(year, month);
};

const getNextMonth = (date: Date): Date => {
  // 获取当前日期的年份和月份
  let year = date.getFullYear();
  let month = date.getMonth();

  // 计算下一个月的年份和月份
  if (month === 11) {
    // 如果当前月份是12月，则下一个月是明年的1月
    year++;
    month = 0; // 1月对应的索引是0
  } else {
    // 否则，直接取下一个月
    month++;
  }

  // 构造并返回下一个月的日期对象
  return new Date(year, month);
};


export const DateUtil = {
    getDateFromTimeString,
    getDateFromDateString,
    getForeMonth,
    getNextMonth,
}